import styled from 'styled-components';

export const Root = styled.div`
	&:hover{
		z-index: 500;
	}

	&:hover p{
		transform: scaleX(1);
		transition: 200ms 200ms;
		transition-timing-function: cubic-bezier(.8,0,.2,1.4);
	}

	&:active > div{
		transform: scale(1.25);
	}

`;

export const Header = styled.div`
	background-color: rgba(255,255,255,0.7);
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	cursor: pointer;
	transition: transform 200ms;

	p{
		white-space: nowrap;
		padding: 15px 20px;
		background: rgba(50,50,50,0.9);
		color: white;
		font-family: 'Poppins', sans-serif;
		font-size: 12px;
		font-weight: bold;
		transform: scaleX(0);
		position: absolute;
		left: 100%;
		top: 0;
		height: 100%;
		transform-origin: left;
		display: flex;
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
			display: block;
			line-height: 1.8;
		}
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	&:hover{
		transform: scale(1.3);
		background-color: rgba(255,255,255,1);
		box-shadow: 0 10px 15px -13px black;
	}
`;

export const IconWrapper = styled.div`
	width: 50px;
	height: 50px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 25px !important;
		height: auto;
	}
`;